var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.567,
    height: 17.07,
    viewBox: "0 0 20.567 17.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-twitter",
    "data-name": "Icon feather-twitter",
    d: "M21.367,4.494a9.843,9.843,0,0,1-2.836,1.382,4.046,4.046,0,0,0-7.1,2.709v.9A9.627,9.627,0,0,1,3.306,5.4s-3.612,8.127,4.515,11.74A10.512,10.512,0,0,1,1.5,18.943c8.128,4.515,18.061,0,18.061-10.385a4.064,4.064,0,0,0-.072-.75,6.972,6.972,0,0,0,1.878-3.314Z",
    transform: "translate(-1.15 -4.072)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter2);
export default __webpack_public_path__ + "static/media/twitter2.4eb912175b1e29c63add0399de096553.svg";
export { ForwardRef as ReactComponent };